import * as types from '../types.js';

export default {

	html: `
		<style>
			#block-stock #stock_sku			{ width: 12rem; }
			#block-stock #lot_display			{ width: 14rem; }
			#block-stock #location_display		{ width: 22rem; }
			#block-stock #quantity				{ width: 6rem; text-align: right; }
			#block-stock #reason				{ width: 100%; max-width: 28rem; }
			#block-stock #movement_kind		{ width: 14rem; }
		</style>
		<form id="block-stock" class="form" autocomplete="off">
			<div class="title">Bloquear estoque</div>
			<p class="mts muted" style="max-width:36rem">Transfere quantidade de <strong>disponível (L)</strong> para <strong>bloqueado (B)</strong> na mesma posição. Exige linha selecionada na grade.</p>
			<div class="fsb mtl">
				<label>SKU
					<input id="stock_sku" type="text" disabled>
				</label>
				<label>Titular / Lote
					<input id="lot_display" type="text" disabled>
				</label>
				<label>Armazém / Posição
					<input id="location_display" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Quantidade disponível a bloquear">Quantidade<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
				<label title="Classificação operacional (mesma lista de Movimentações)">Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
			</div>
			<div class="fsb mtm">
				<label style="flex:1;max-width:28rem">Motivo<sup>*</sup>
					<input id="reason" type="text" required placeholder="Ex.: quarentena, auditoria">
				</label>
			</div>
			<input id="lot_company_id" type="hidden">
			<input id="lot_id" type="hidden">
			<input id="source_warehouse_company_id" type="hidden">
			<input id="source_warehouse_id" type="hidden">
			<input id="source_location_id" type="hidden">
			<input id="target_warehouse_company_id" type="hidden">
			<input id="target_warehouse_id" type="hidden">
			<input id="target_location_id" type="hidden">
			<input id="qty_available_max" type="hidden">
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Bloquear</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#block-stock',
		init(formset) {
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#stock_sku' }, types: [] },
		{ properties: { selector: '#lot_display' }, types: [] },
		{ properties: { selector: '#location_display' }, types: [] },
		{ properties: { selector: '#quantity' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#movement_kind' }, types: [types.opt_movement_kind(), types.datalist()] },
		{ properties: { selector: '#reason' }, types: [] },
		{ properties: { selector: '#lot_company_id' }, types: [] },
		{ properties: { selector: '#lot_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#source_warehouse_company_id' }, types: [] },
		{ properties: { selector: '#source_warehouse_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#source_location_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#target_warehouse_company_id' }, types: [] },
		{ properties: { selector: '#target_warehouse_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#target_location_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#qty_available_max' }, types: [types.number(0, 2)] },
	],
};
